import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import BottomSheet from "../BottomSheet/BottomSheet";

/**
 * ShippingBar
 *
 * Slim, full-width info-only announcement bar (replaces the old promo card).
 * The ⓘ button opens a bottom sheet with the full shipping & delivery detail.
 * International (USD region) has no ₹499 free-ship threshold — flat $25, prepaid.
 */
export default function ShippingBar() {
  const { t } = useTranslation();
  const [sheet, setSheet] = useState(false);
  const isIntl = useSelector((s) => s.location?.currency) === "USD";

  return (
    <>
      <div className="flex items-center justify-center gap-2 px-[14px] py-[9px] bg-[#F4F5FF] text-ink-700 text-[11.5px] font-[400] text-center border-b border-s-primary/[0.12]">
        <span>
          {isIntl ? t("shippingBar.intl") : t("shippingBar.domestic")}
        </span>
        <button
          type="button"
          onClick={() => setSheet(true)}
          aria-label={t("shippingBar.detailsLabel")}
          className="border-0 bg-transparent text-s-primary text-[14px] font-[500] leading-none p-0"
        >
          ⓘ
        </button>
      </div>

      <BottomSheet sheet={sheet} setSheet={setSheet} height="55">
        <h3 className="text-[15px] font-[400] text-ink-900 mb-3">
          {t("shippingBar.sheetTitle")}
        </h3>
        <div className="text-[12px] leading-[1.55] text-ink-700 space-y-[9px]">
          <p>
            <Trans
              i18nKey="shippingBar.india"
              components={[
                <b className="text-ink-900 font-[400]" />,
                <b className="text-ink-900 font-[400]" />,
              ]}
            />
          </p>
          <p>
            <Trans
              i18nKey="shippingBar.international"
              components={[
                <b className="text-ink-900 font-[400]" />,
                <b className="text-ink-900 font-[400]" />,
              ]}
            />
          </p>
          <p>
            <Trans
              i18nKey="shippingBar.deliveryTime"
              components={[<b className="text-ink-900 font-[400]" />]}
            />
          </p>
          <p>
            <Trans
              i18nKey="shippingBar.returns"
              components={[<b className="text-ink-900 font-[400]" />]}
            />
          </p>
        </div>
      </BottomSheet>
    </>
  );
}
